import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Checkbox, Form, TextArea, Input, Confirm } from 'semantic-ui-react';
import i18n from 'i18next';
import { setCustomerInfo, setRemarkToOrder } from '../../actions';

import './ContactForm.scss';

const ContactForm = (props) => {
    const dispatch = useDispatch();
    const customer = useSelector(state => state.customer);
    const orderRemarks = useSelector(state => state.order.cart.remarks);
    const supportTableNumberField = useSelector(state => state.business.supportTableNumberField);
    const [termsAgreed, setTerms] = useState(false);
    const [confirmTerms, toggleTermsConfirm] = useState(false);

    const requiredSign = () => {
        return <span className="required-sign">*</span>;
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;

        dispatch(setCustomerInfo({ ...customer, [name]: value }));
    };

    const handleSubmit = (e) => {
        if (termsAgreed) {
            props.onSubmit();
        } else {
            toggleTermsConfirm(true);
        }
        e.preventDefault();
    };

    return (
        <Form className="pi-contact-form" onSubmit={handleSubmit}>
            <Form.Field>
                <label>{i18n.t('contact.name')}{requiredSign()}</label>
                <Input
                    placeholder={i18n.t('contact.name')}
                    name="name"
                    required
                    value={customer.name}
                    onChange={handleInputChange}
                />
            </Form.Field>
            {supportTableNumberField &&
                <Form.Field>
                    <label>{i18n.t('contact.tableNumber')}</label>
                    <Input
                        placeholder={i18n.t('contact.tableNumber')}
                        name="tableLocation"
                        maxLength={50}
                        value={customer.tableLocation || ''}
                        onChange={handleInputChange}
                    />
                </Form.Field>
            }
            <Form.Field>
                <label>{i18n.t('contact.phone')}{requiredSign()}</label>
                <Input
                    placeholder={i18n.t('contact.phonePlaceholder')}
                    type="tel"
                    required
                    name="phone"
                    pattern="^(?=.*[0-9])[- +()0-9]+$"
                    value={customer.phone}
                    onChange={handleInputChange}
                />
            </Form.Field>
            <Form.Field>
                <label>{i18n.t('contact.email')}{requiredSign()}</label>
                <Input
                    placeholder={i18n.t('contact.emailPlaceholder')}
                    type="email"
                    required
                    name="email"
                    value={customer.email}
                    onChange={handleInputChange}
                />
            </Form.Field>
            <Form.Field
                control={TextArea}
                label={i18n.t('contact.orderRemarks')}
                placeholder={i18n.t('contact.orderRemarksHint')}
                value={orderRemarks}
                onChange={e => dispatch(setRemarkToOrder(e.target.value))}
            />
            <Form.Field style={{ display: 'flex' }}>
                <Checkbox checked={termsAgreed} onChange={() => setTerms(!termsAgreed)} />
                <span style={{ marginLeft: 5, marginRight: 5 }}>
                    {i18n.t('contact.termsAgreenent')}{' '}
                    <a href={'http://paidit.io/terms'} target="_blank" rel="noopener noreferrer">{i18n.t('contact.terms')}</a>{' '}
                    <a href={'http://paidit.io/privacy'} target="_blank" rel="noopener noreferrer">{i18n.t('contact.privacy')}</a>
                </span>
            </Form.Field>
            <Button primary fluid type='submit'>{i18n.t('payment.toPayment')}</Button>
            <Confirm
                open={confirmTerms}
                content={i18n.t('contact.termsConfirm')}
                cancelButton={i18n.t('general.no')}
                confirmButton={i18n.t('general.yes')}
                centered
                onCancel={() => toggleTermsConfirm(false)}
                onConfirm={() => {
                    setTerms(!termsAgreed);
                    toggleTermsConfirm(false);
                    props.onSubmit();
                }}
            />
        </Form>
    );
};

ContactForm.propTypes = {
    onSubmit: PropTypes.func
};

export default ContactForm;
